import { render } from "./LargeOption.vue?vue&type=template&id=528e0a4b&scoped=true"
import script from "./LargeOption.vue?vue&type=script&lang=js"
export * from "./LargeOption.vue?vue&type=script&lang=js"

import "./LargeOption.vue?vue&type=style&index=0&id=528e0a4b&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528e0a4b"]])

export default __exports__